import HomeView from "./views/HomeView.vue";
import LoginView from "./views/LoginView.vue";
import DayView from "./views/DayView.vue";
import WeekView from "./views/WeekView.vue";
import MonthView from "./views/MonthView.vue";
import CategoryView from "./views/CategoryView.vue";
import ChangelogView from "./views/ChangelogView.vue";
import HelpView from "./views/HelpView.vue";
import RealtimeView from "./views/RealtimeView.vue";
import LineView from "./views/LineView.vue";
import TrendView from "./views/TrendView.vue";

// import SentryTest from './components/SentryTest.vue';

export default [
  { path: "/", component: HomeView },
  { path: "/login", component: LoginView },
  { path: "/day/:date?/:mode?", component: DayView, alias: "/today" },
  { path: "/week/:week?", component: WeekView },
  { path: "/month/:month?", component: MonthView },
  { path: "/category/:id?", component: CategoryView },
  { path: "/changes", component: ChangelogView },
  { path: "/help", component: HelpView },
  { path: "/realtime", component: RealtimeView },
  { path: "/line", component: LineView },
  { path: "/trend", component: TrendView },
  // { path: '/sentry', component: SentryTest },
  // { path: '*', component: NotFound } TODO - Implement this
];



// WEBPACK FOOTER //
// ./dev/src/routes.js